import "core-js/modules/es.number.constructor.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.podeCopiarCadastrosEmpresa ? _c('div', {
    staticClass: "cadastro-empresa-copiar"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bolder font-size-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.quantidadeSelecionada === 0
    },
    on: {
      "click": _vm.abrirModal
    }
  }, [_vm._v(" Copiar para empresas "), _vm.quantidadeSelecionada ? _c('span', {
    staticClass: "label label-primary ml-2"
  }, [_vm._v(" " + _vm._s(_vm.quantidadeSelecionada) + " ")]) : _vm._e()]), _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "Copiar cadastros para empresas",
      "ok-title": "Copiar cadastros",
      "cancel-title": "Cancelar",
      "ok-disabled": _vm.empresasSelecionadas.length === 0 || _vm.copiando,
      "cancel-disabled": _vm.copiando,
      "no-close-on-backdrop": ""
    },
    on: {
      "ok": _vm.copiar
    }
  }, [_c('p', {
    staticClass: "mb-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.quantidadeSelecionada))]), _vm._v(" " + _vm._s(_vm.quantidadeSelecionada === 1 ? "registro selecionado" : "registros selecionados") + ". Escolha as empresas que receberão uma cópia. ")]), _c('div', {
    staticClass: "bg-light rounded px-4 py-3 mb-4"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Empresa de origem:")]), _c('strong', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.nomeEmpresaCadastro(_vm.empresaContexto)))])]), _c('div', {
    staticClass: "border rounded px-4 py-3"
  }, _vm._l(_vm.empresasFiliaisCadastro, function (empresa) {
    return _c('b-form-checkbox', {
      key: empresa.id_empresa,
      staticClass: "mb-2",
      attrs: {
        "value": Number(empresa.id_empresa)
      },
      model: {
        value: _vm.empresasSelecionadas,
        callback: function callback($$v) {
          _vm.empresasSelecionadas = $$v;
        },
        expression: "empresasSelecionadas"
      }
    }, [_vm._v(" " + _vm._s(_vm.nomeEmpresaCadastro(empresa)) + " "), _c('span', {
      staticClass: "text-muted ml-1"
    }, [_vm._v(" (" + _vm._s(empresa.tipo_grupo === "MATRIZ" ? "Matriz" : "Filial") + ") ")])]);
  }), 1), _c('small', {
    staticClass: "text-muted d-block mt-3"
  }, [_vm._v(" Cadastros que já existirem na empresa serão mantidos e ignorados. ")])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };